import cleave from "../services/cleave";

export const PhoneNumberMixin = {
  directives: { cleave },

  data() {
    return {
      masks: {
        frenchPhone: {
          delimiters: ["-"],
          blocks: [2, 2, 2, 2, 2],
          numericOnly: true
        }
      }
    };
  },

  methods: {
    onPhoneNumberInput(event) {
      this.phone = event.target._vCleave.getFormattedValue();
    },

    phoneNumberKeyDown(event) {
      let key = event.key;
      if (key === "ArrowLeft" || key === "ArrowRight" || key === "Backspace") {
        return;
      }
      if (key.match(/\D/)) {
        event.target.value += "";
        event.preventDefault();
      }
    }
  }
};
